<blaze-dialog
  (closeDialog)="onCloseDialog()"
  [class.hidden]="!isDialogVisible()"
  [contentClass]="'user-profile-dialog-content'"
  [contentHasPadding]="true"
  [formGroup]="userProfileForm"
  [showFooter]="true"
  class="user-profile-dialog"
>
  <ng-container icon>
    <mat-icon class="menu-icon" svgIcon="icon_var_user_16" />
  </ng-container>

  <ng-container class="title" title>My Profile</ng-container>

  <ng-container content>
    <div class="content-section">
      <h3 class="content-header">My Information</h3>

      <div class="content-card user-info">
        <!-- user avatar -->
        <div class="user-info__photo" [class.with-avatar]="avatarSrc()">
          <img
            alt="Avatar"
            loading="lazy"
            src="{{ avatarSrc() || 'assets/image-placeholders/avatar-placeholder.svg' }}"
          />
          <div class="avatar-overlay">
            <div class="avatar-actions">
              @if (user() && !avatarSrc()) {
                <button
                  (click)="$event.stopPropagation(); avatarUpload.click()"
                  blazeIconButton
                  data-cy="UserProfileDialog:avatarAdd"
                  type="button"
                >
                  <mat-icon class="icon-16" svgIcon="icon_add_16" />
                </button>
              } @else if (user() && avatarSrc()) {
                <div class="edit-delete-buttons">
                  <button
                    (click)="$event.stopPropagation(); avatarUpload.click()"
                    blazeIconButton
                    data-cy="UserProfileDialog:avatarEdit"
                    type="button"
                  >
                    <mat-icon class="icon-16" svgIcon="icon_edit_16" />
                  </button>
                  <button
                    (click)="onAvatarDelete()"
                    blazeIconButton
                    data-cy="UserProfileDialog:avatarDelete"
                    type="button"
                  >
                    <mat-icon class="icon-16 !text-warn" svgIcon="icon_trash" />
                  </button>
                </div>
              }
            </div>
            <input
              #avatarUpload
              (change)="onFileSelected($event.target)"
              accept="{{ acceptedImageExtensions }}"
              hidden
              multiple="false"
              type="file"
            />
          </div>
        </div>

        <!-- first, last, email -->
        <div class="user-info__info">
          <div class="info-row">
            <span class="input-label">First Name</span>
            <input formControlName="firstName" type="text" class="bd-text-input tall" />
          </div>
          <div class="info-row">
            <span class="input-label">Last Name</span>
            <input formControlName="lastName" type="text" class="bd-text-input tall" />
          </div>
          <div class="info-row">
            <span class="input-label">Email</span>
            <input
              [disabled]="true"
              class="bd-text-input tall"
              formControlName="email"
              type="text"
            />
          </div>
          @if (userHasPasswordLogin()) {
            <div class="info-row mt-16 justify-end">
              <a class="font-medium" (click)="onChangePassword()">Change Account Password</a>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="content-section">
      <h3 class="content-header">Two-Factor Authentication</h3>
      <div class="content-card authentication">
        <!-- Two Factor Authentication -->
        <blaze-two-factor-auth
          (dialogVisible)="onSecondaryDialogVisible($event)"
          (userUpdated)="user.set($event)"
          [user]="user()"
          [userHasPasswordLogin]="userHasPasswordLogin()"
        />
      </div>
    </div>
  </ng-container>

  <ng-container footer>
    <button
      (click)="onSaveUserProfile()"
      [disabled]="!userProfileForm.valid || !userProfileForm.dirty"
      blazeButton="primary"
      class="uppercase"
    >
      Save
    </button>
  </ng-container>
</blaze-dialog>
